import { faFileSlash } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import { themeClass } from '~/styles/theme.css'
import {
  attachmentsGeneratingSubtitle,
  attachmentsGeneratingTitle,
  noAttachments,
  noAttachmentsIcon
} from '../AttachmentsViewer.css'

export const UnavailableViewer = () => (
  <div className={clsx(noAttachments, themeClass)}>
    <div className={noAttachmentsIcon}>
      <FontAwesomeIcon icon={faFileSlash} />
    </div>
    <div className={attachmentsGeneratingTitle}>
      Erreur lors du chargement du document
    </div>
    <div className={attachmentsGeneratingSubtitle}>
      Le contenu du document n'est pas disponible.
    </div>
  </div>
)
